import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router';
import { PageWrapperBox } from './RegisterFromInvitation.style-elements';
import RegisterFromInvitationErrorStep from './Steps/RegisterFromInvitationErrorStep';
import { steps } from './RegisterFromInvitation.utils';
import { RegisterFromInvitationDataProps } from './Steps/Steps.types';

const RegisterFromInvitation: React.FC = () => {
  const { id: newUserInvitationId } = useParams();
  const [currentStepIdx, setCurrentStepIdx] = useState<number>(1);
  const [
    registerData,
    setRegisterData,
  ] = useState<RegisterFromInvitationDataProps>({});

  const moveToNextStep = (props?: Partial<RegisterFromInvitationDataProps>) => {
    setRegisterData((currentData) => ({
      ...currentData,
      ...props,
    }));
    setCurrentStepIdx((idx) => Math.min(idx + 1, steps.length));
  };

  const moveToPrevStep = () => {
    setCurrentStepIdx((idx) => Math.max(idx - 1, 1));
  };

  useEffect(() => {
    console.log('registerData', registerData);
  }, [registerData]);

  if (newUserInvitationId !== '1') {
    return <RegisterFromInvitationErrorStep />;
  }

  return (
    <PageWrapperBox>
      {steps.map(
        ({ stepId, Component }) =>
          currentStepIdx === stepId && (
            <Component
              key={stepId}
              onGoNext={moveToNextStep}
              onGoPrev={moveToPrevStep}
              {...registerData}
            />
          )
      )}
    </PageWrapperBox>
  );
};

export default RegisterFromInvitation;
